<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('application.utilitymodel.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
          <span class="front_loc">{{ $t('application.title') }} > </span>
          <span class="middle_loc">{{ $t('application.utilitymodel.title2') }} > </span>
          <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type3">
            <v-flex class="step_box step01 cursor_pointer" @click="fnGoBefore('1')">
              <h2>{{ $t('application.utilitymodel.fields.step_01') }}</h2>
              <p>
                {{ $t('application.utilitymodel.fields.select_type_and_input') }}
                <br/>
                {{ $t('application.utilitymodel.fields.related_application') }}
              </p>
            </v-flex>
            <v-flex class="step_box step02 cursor_pointer" @click="fnGoBefore('2')">
              <h2>{{ $t('application.utilitymodel.fields.step_02') }}</h2>
              <p>{{ $t('application.utilitymodel.fields.write_application') }}</p>
            </v-flex>
            <v-flex class="step_box step03 cursor_pointer" @click="fnGoBefore('3')">
              <h2>{{ $t('application.utilitymodel.fields.step_03') }}</h2>
              <p>{{ $t('application.utilitymodel.fields.attach_file(s)') }}</p>
            </v-flex>
            <v-flex class="active step_box step04">
              <h2>{{ $t('application.utilitymodel.fields.step_04') }}</h2>
              <p>{{ $t('application.utilitymodel.fields.review_submit') }}</p>
            </v-flex>
            <v-flex class="step_box step05">
              <h2>{{ $t('application.utilitymodel.fields.step_05') }}</h2>
              <p>{{ $t('application.utilitymodel.fields.payment') }}</p>
            </v-flex>
          </v-layout>
          <v-layout class="inner_contents mt-30" column>
            <v-flex>
              <v-tabs
                v-model="activeTab"
                class="my_app_tabs_data type2 st2"
                hide-slider
                grow
              >
                <v-tab :href="'#tab-1'">{{$t('application.fields.select_representative')}}<br>{{$t('application.fields.drawing')}}
                  <v-icon v-if="confirm.ind_drawing_confirm == 'Y'" class="tabs_confirm_icon" icon>mdi-check</v-icon>
                </v-tab>
                <v-tab :href="'#tab-2'">{{$t('application.fields.review')}}<br>{{$t('application.fields.your_application')}}
                  <v-icon v-if="confirm.ind_review_confirm  == 'Y'" class="tabs_confirm_icon" icon>mdi-check</v-icon>
                </v-tab>
                <v-tab :href="'#tab-4'">{{$t('application.fields.check_missing')}}<br>{{$t('application.fields.documents')}}
                  <v-icon v-if="confirm.ind_missing_doc_confirm  == 'Y'" class="tabs_confirm_icon" icon>mdi-check</v-icon>
                </v-tab>
                <v-tab :href="'#tab-5'">{{$t('application.fields.attached_documents')}}
                  <v-icon v-if="confirm.ind_attached_document == 'Y'" class="tabs_confirm_icon" icon>mdi-check</v-icon>
                </v-tab>

                <v-tab-item :value="`tab-1`">
                  <Drawings
                    ref="drawings"
                    :receipt_no.sync="receipt_no"
                    @representative="fnSetReviewFront()"
                    v-if="flag_tab1"
                  />

                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore('3')"
                          :loading="loadingBefore"
                          :disabled="loadingBefore"
                        >{{ $t('common.button.before') }}</v-btn>

                        <v-btn
                          v-if="confirm.ind_drawing_confirm == 'N'"
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click.stop="fnConfirmDrawing('Y')"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          v-if="confirm.ind_drawing_confirm == 'Y'"
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click.stop="fnConfirmDrawing('N')"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoNext()"
                          :disabled="(loadingNext) ? loadingNext : nextDisabledYn"
                          :loading="loadingNext"
                        >
                          {{ $t('common.button.next') }}
                          <v-icon dark right>mdi-check</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-tab-item>


                <v-tab-item :value="`tab-2`">
                  <ReviewUtility
                    :receipt_no.sync="receipt_no"
                    v-if="flag_tab2"
                    @success="fnSetSignFileKey"
                  />

                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore('3')"
                          :loading="loadingBefore"
                          :disabled="loadingBefore"
                        >{{ $t('common.button.before') }}</v-btn>

                        <v-btn
                          v-if="confirm.ind_review_confirm == 'N'"
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click.stop="fnConfirmReview('Y')"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          v-if="confirm.ind_review_confirm == 'Y'"
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click.stop="fnConfirmReview('N')"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoNext()"
                          :disabled="(loadingNext) ? loadingNext : nextDisabledYn"
                          :loading="loadingNext"
                        >
                          {{ $t('common.button.next') }}
                          <v-icon dark right>mdi-check</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-tab-item>

                <v-tab-item :value="`tab-4`">
                  <v-layout class="mt-40" column>
                    <CheckMissingDocuments ref="check_missing_document" :receipt_no.sync="receipt_no" :filling.sync="filling"/>
                  </v-layout>

                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore('3')"
                          :loading="loadingBefore"
                          :disabled="loadingBefore"
                        >{{ $t('common.button.before') }}</v-btn>

                        <v-btn
                          v-if="confirm.ind_missing_doc_confirm == 'N'"
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click.stop="fnConfirmMissingdoc('Y')"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          v-if="confirm.ind_missing_doc_confirm == 'Y'"
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click.stop="fnConfirmMissingdoc('N')"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoNext()"
                          :disabled="(loadingNext) ? loadingNext : nextDisabledYn"
                          :loading="loadingNext"
                        >
                          {{ $t('common.button.next') }}
                          <v-icon dark right>mdi-check</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-tab-item>

                <v-tab-item :value="`tab-5`">
                  <DocumentViewer
                    :items="documentFileList"
                  />
                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore('3')"
                          :loading="loadingBefore"
                          :disabled="loadingBefore"
                        >{{ $t('common.button.before') }}</v-btn>

                        <v-btn
                          v-if="confirm.ind_attached_document == 'N'"
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click.stop="fnConfirmAttacheddoc('Y')"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          v-if="confirm.ind_attached_document == 'Y'"
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click.stop="fnConfirmAttacheddoc('N')"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoNext()"
                          :disabled="(loadingNext) ? loadingNext : nextDisabledYn"
                          :loading="loadingNext"
                        >
                          {{ $t('common.button.next') }}
                          <v-icon dark right>mdi-check</v-icon>
                        </v-btn>
                      </div>

                    </div>
                  </div>

                </v-tab-item>
              </v-tabs>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

    </v-layout>
    <confirm-dialog
      :id="id"
      @moveNextPage="fnMoveNextPage"
    />
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import Drawings from '@/components/layout/Drawings'
import ReviewUtility from '@/components/layout/ReviewUtility'
import DocumentViewer from '@/components/layout/DocumentViewer'
import CheckMissingDocuments from '@/components/layout/CheckMissingDocuments'
import ConfirmDialog from '@/components/layout/ConfirmDialog'

export default {
  name : 'UtilityModelStep4',
  components :{
    Drawings,
    ReviewUtility,
    DocumentViewer,
    CheckMissingDocuments,
    ConfirmDialog
  },
  data () {
    return {
      id : 'UtilityModelStep4',
      flag_tab1 : false,
      flag_tab2 : false,
      flag_tab3 : false,
      flag_tab4 : false,
      flag_tab5 : false,
      flag_review: true,
      loadingBefore: false,
      loadingNext: false,

      sign_image : '',

      //
      activeTab : 'tab-1',
      receipt_no : this.$route.params.receipt_no,
      confirm : {
        ind_drawing_confirm : '',
        ind_review_confirm  : '',
        ind_front_page_confirm : '',
        ind_missing_doc_confirm  : '',
        ind_attached_document  : ''
      },

      documentFileList: [],
      filling: null
    }
  },
  computed : {
    nextDisabledYn (){
      return (this.confirm.ind_drawing_confirm == 'N' ||
              this.confirm.ind_review_confirm == 'N' ||
              this.confirm.ind_missing_doc_confirm == 'N' ||
              this.confirm.ind_attached_document == 'N')
    }
  },
  watch:{
    activeTab(){
      if(this.activeTab == 'tab-1'){
          this.flag_tab1 = true
      } else if(this.activeTab == 'tab-2'){
          this.flag_tab2 = true
      } else if(this.activeTab == 'tab-3'){
          this.flag_tab3 = true
      } else if(this.activeTab == 'tab-4'){
          this.flag_tab4 = true
      } else if(this.activeTab == 'tab-5'){
          this.flag_tab5 = true
      }
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.flag_tab1 = true

    this.fnGetReceipt()
    this.fnGetIndConfirmList()
    this.fnGetDocumentFileList()


    // 푸터 여백 처리
    document.querySelectorAll('.copyright_wrap')[0].classList.add('mb-45')
    document.querySelectorAll('.copyright_wrap')[0].classList.add('bp480')

  },
  beforeDestroy(){
    document.querySelectorAll('.copyright_wrap')[0].classList.remove('mb-45')
    document.querySelectorAll('.copyright_wrap')[0].classList.remove('bp480')
  },
  methods: {
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6403'
              || res.data.receipt_status_type_code !== '4301'
              || res.data.receipt_step < 4) {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetIndConfirmList(){
      requestApi({
        url: '/receivings/utility/' + this.receipt_no + '/filing',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.confirm.ind_drawing_confirm  = res.data.ind_drawing_confirm
            this.confirm.ind_review_confirm  = res.data.ind_review_confirm
            this.confirm.ind_front_page_confirm  = res.data.ind_front_page_confirm
            this.confirm.ind_missing_doc_confirm  = res.data.ind_missing_doc_confirm
            this.confirm.ind_attached_document  = res.data.ind_attached_document

            this.sign_image = res.data.sign_image
            this.filling = res.data

            if(utils.isNull(this.sign_image)) {
              this.fnGetProfile()
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetIndConfirmList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnConfirmDrawing(confirmVal){
      if(confirmVal == 'Y'){
        if(this.$refs.drawings.drawingList.length > 0 && !this.$refs.drawings.hasRepresentative){
          let option = {
            text : this.$t('application.patent.fields.msg_no_representative')
          }
          eventBus.$emit('SHOW_SNACKBAR', option)
          return
        }
      }

      let params = {
        ind_drawing_confirm : confirmVal
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/confirm/drawing',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.fnGetMessage(confirmVal)
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.confirm.ind_drawing_confirm = confirmVal

            //다음탭으로 넘김
            if(confirmVal == 'Y'){
              this.activeTab = 'tab-2'
            }

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmDrawing(confirmVal)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnConfirmReview(confirmVal){
      let params = {
        ind_review_confirm : confirmVal
      }

      let runFlag = false
      if(confirmVal == 'Y'){
        if(this.sign_image){
          runFlag = true
        }else{
          runFlag = false

          let snackBarOptions = {
            text: this.$t('application.utilitymodel.fields.input_sign_image')
          }
          eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        }
      }else{
        runFlag = true
      }

      if(runFlag){
        requestApi({
          url: '/receivings/' + this.receipt_no + '/confirm/review',
          method: 'PUT',
          data: params,
          callback: (res) => {
            if (res.res_code === '200') {
              let snackBarOptions = {
                text: this.fnGetMessage(confirmVal)
              }
              eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
              this.confirm.ind_review_confirm = confirmVal

              //다음탭으로 넘김
              if(confirmVal == 'Y'){
                this.activeTab = 'tab-4'
              }

            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnConfirmReview(confirmVal)
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    fnConfirmFrontpage(confirmVal){
      let params = {
        ind_front_page_confirm : confirmVal
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/confirm/frontpage',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.fnGetMessage(confirmVal)
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.confirm.ind_front_page_confirm = confirmVal

            //다음탭으로 넘김
            if(confirmVal == 'Y'){
              this.activeTab = 'tab-4'
            }

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmFrontpage(confirmVal)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnConfirmMissingdoc(confirmVal){

      let check_missing_documents = []

      let missingdocuments = this.$refs.check_missing_document.missingdocuments
      for(let i=0; i<missingdocuments.length; i++){
        let item_param = {
          ind_submitted : missingdocuments[i].ind_submitted ? missingdocuments[i].ind_submitted : 'N',
          check_missing_type_code : missingdocuments[i].check_missing_type_code
        }

        check_missing_documents.push(item_param)
      }

      let params = {
        ind_missing_doc_confirm : confirmVal,
        check_missing_documents : check_missing_documents
      }

      requestApi({
        url: '/receivings/' + this.receipt_no + '/confirm/missingdoc',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.fnGetMessage(confirmVal)
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.confirm.ind_missing_doc_confirm = confirmVal

            //다음탭으로 넘김
            if(confirmVal == 'Y'){
              this.activeTab = 'tab-5'
            }

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmMissingdoc(confirmVal)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnConfirmAttacheddoc(confirmVal){
      let params = {
        ind_attached_document : confirmVal
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/confirm/attacheddoc',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.fnGetMessage(confirmVal)
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.confirm.ind_attached_document = confirmVal
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmAttacheddoc(confirmVal)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetMessage(val){
      return val == 'Y' ? this.$t('common.message.confirm.success') : this.$t('common.message.cancel_confirm.success')
    },
    fnGoBefore(step){
      this.loadingBefore = true
      this.$router.push({ path : '/application/utilitymodel/step'+ step +'/' + this.$route.params.receipt_no })
    },
    // 다음 화면으로 이동
    fnGoNext(){
      let options = {
        text: this.$t('common.message.application_submit.confirm.text'),
        yes: {
          text: this.$t('common.button.yes'),
          event: 'moveNextPage',
          callback: {}
        },
        no: {
          text: this.$t('common.button.no')
        }
      }
      eventBus.$emit('SHOW_CONFIRM_DIALOG'+ this.id, options)
    },

    fnMoveNextPage(){
      this.loadingNext = true
      let params = {
        sign_image: this.sign_image
      }
      requestApi({
        url: '/receivings/utility/' + this.$route.params.receipt_no + '/submit',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.$router.push({ path : '/application/utilitymodel/step5/' + this.$route.params.receipt_no })
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnMoveNextPage()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              this.loadingNext = false
            }
          }
        }
      })
    },

    fnSetSignFileKey(sign_image){
      this.sign_image = sign_image
    },

    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSetReviewFront() {
      this.flag_review = false

      this.$nextTick().then(() => {
        this.flag_review = true
      })
    },

    fnGetProfile(){
      requestApi({
        url: '/users/profile',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data.representative_sign_image){
              this.sign_image = res.data.representative_sign_image
            } else if(res.data.sign_image) {
              this.sign_image = res.data.sign_image
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetProfile()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.opacity_50 {
  opacity : 0.5;
}

.copyright_wrap{
  padding-bottom:75px;
}
</style>